import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./styles.css";

const ExportButton = ({ handleExport, pathname, data, from, columns }) => {
  return (
    <>
      <Button
        className="btn-excel btn-action"
        type="text"
        variant={"success"}
        onClick={handleExport("excel")}
      >
        Excel
      </Button>
      <Link
        to={{
          pathname: pathname,
          state: { data, from: from, columns: columns },
        }}
      >
        <Button
          className="btn-pdf btn-action"
          type="text"
          variant={"primary"}
        >
          PDF
        </Button>
      </Link>
    </>
  );
};

export default ExportButton;
